const _ = require('./enum');

module.exports = {
  [_.AUTHENTICATION]: { id: _.AUTHENTICATION, label: 'Authentication', color: 'grey' },
  [_.AUTHORIZATION]: { id: _.AUTHORIZATION, label: 'Authorization', color: 'blue' },
  [_.CANCEL]: { id: _.CANCEL, label: 'Cancel', color: 'yellow' },
  [_.CAPTURE]: { id: _.CAPTURE, label: 'Capture', color: 'green' },
  [_.CHARGEBACK]: { id: _.CHARGEBACK, label: 'Chargeback', color: 'red' },
  [_.CREDIT]: { id: _.CREDIT, label: 'Credit', color: 'orange' },
  [_.REFUND]: { id: _.REFUND, label: 'Refund', color: 'orange' },
  [_.RISK_ASSESSMENT]: { id: _.RISK_ASSESSMENT, label: 'Risk assessment', color: 'grey' },
};
